import {Box} from '@chakra-ui/layout';
import {useTranslation} from 'react-i18next';
import {BoxProps} from '@chakra-ui/react';

/**
 * Badge signalant un panier issu d'un import PDF de commande.
 */
export const PdfBadge: React.FC<BoxProps> = (props) => {
  const {t} = useTranslation();
  return (
    <Box
      px='2.5'
      py='0.5'
      borderRadius='8px'
      backgroundColor='gray.light'
      color='gray.dark'
      fontSize='xs'
      fontWeight='600'
      {...props}
    >
      {t('panier.pdf')}
    </Box>
  );
};
